import React, { useEffect, useRef, useState } from "react";
import { Button, MenuItem, Select } from "@mui/material";
import { ToastManager } from "../../Toast/ToastManager";
import { POST_SERVICES } from "../../../services";
import { POST_STATUS } from "../../../common/constants";

const CompanyPostFilter = props => {
  const { setPostsAction, filter, onChangeFilter, orgId } = props;
  const [categoryList, setCategoryList] = useState([]);
  const [tagList, setTagList] = useState([]);
  const dataFetched = useRef(null);

  useEffect(() => {
    if (dataFetched?.current) return;
    dataFetched.current = true;
    POST_SERVICES.categoryList()
      .then(data => {
        if (data.code === 200) {
          setCategoryList(data?.data);
        } else {
          ToastManager.addToast({ title: data.message });
        }
      })
      .catch(err => {
        ToastManager.addToast({ title: err.message });
      });
    POST_SERVICES.tagList({ accountId: orgId })
      .then(data => {
        if (data.code === 200) {
          setTagList(data?.data || []);
        } else {
          ToastManager.addToast({ title: data.message });
        }
      })
      .catch(err => {
        ToastManager.addToast({ title: err.message });
      });
  }, [orgId]);
  return (
    <div className="product-launch-header">
      <div className="product-launch-header-type">
        <Select
          className="custom-select"
          sx={{
            height: "42px",
            background: "transparent !important",
            width: "100%",
          }}
          value={filter?.status}
          onChange={e => onChangeFilter("status", e.target.value)}
          displayEmpty
        >
          <MenuItem disabled>Filter Visibility</MenuItem>

          <MenuItem value="">All</MenuItem>
          {Object.keys(POST_STATUS)?.map((item, key) => {
            return (
              <MenuItem key={key} value={POST_STATUS?.[item]?.value}>
                {POST_STATUS?.[item]?.name}
              </MenuItem>
            );
          })}
        </Select>
      </div>

      {categoryList?.length > 0 ? (
        <div className="product-launch-header-type">
          <Select
            className="custom-select"
            sx={{
              height: "42px",
              background: "transparent !important",
              width: "100%",
            }}
            value={filter?.category}
            onChange={e => onChangeFilter("category", e.target.value)}
            displayEmpty
          >
            <MenuItem disabled>Filter Category</MenuItem>
            <MenuItem value="">All</MenuItem>
            {categoryList?.map((item, key) => {
              return (
                <MenuItem key={key} value={item.id}>
                  {item?.name}
                </MenuItem>
              );
            })}
          </Select>
        </div>
      ) : null}
      {tagList?.length ? (
        <div className="product-launch-header-type">
          <Select
            className="custom-select"
            sx={{
              height: "42px",
              background: "transparent !important",
              width: "100%",
            }}
            value={filter?.tags}
            onChange={e => onChangeFilter("tags", e.target.value)}
            displayEmpty
          >
            <MenuItem disabled>Filter Tag</MenuItem>
            <MenuItem value="">All</MenuItem>
            {tagList?.map((item, key) => {
              return (
                <MenuItem key={key} value={item}>
                  {item}
                </MenuItem>
              );
            })}
          </Select>
        </div>
      ) : null}

      <Button
        color="primary"
        variant="outlined"
        className="events6ix-btn events6ix-btn-primary ml-auto "
        onClick={() => setPostsAction("create")}
      >
        Create post
      </Button>
    </div>
  );
};

export default CompanyPostFilter;
